import { Grid, Typography, Button } from '@mui/material'
import React from 'react'
import colors from '../../../colors'
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import {setSelectedBank} from '../../../../features/userInfo/topUpSlice'
import { makeStyles } from '@mui/styles';

const SingleBank = (props) => 
{
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const bankData = {
        bankImage: props.bankData.LogoPath,
        bankName : props.bankData.BankName,
        bankColor: props.bankData.Color,
        cif: props.bankData.Cif,
        isActive: props.bankData.Active,
        isPending: props.bankData.Pending,
        bankId: props.bankData.Id
    }

    const handleButtonClick = () => 
    {
        dispatch(setSelectedBank(bankData))
        navigate('topUpBank')
    }

    const useStyles = makeStyles({
        button:{
            background:bankData.bankColor,
            width:'130px',
            height:'130px',
            borderRadius:'15px',
            "&:hover":{backgroundColor:bankData.bankColor}
        },
        bankName:{
            color:colors.darkBlue,
            textTransform:'none',
            fontFamily:'GerberaBold'
        },
        bankImage:{
            width:'100%',
            height:'100%',
            background:bankData.bankColor
        }
    })

    const classes = useStyles()

    return (
        <Grid container rowSpacing={2} justifyContent={'center'} pt={5} >
            <Button className={classes.button} onClick={handleButtonClick}>
                <Grid container flexDirection='column' rowSpacing={1}  >
                    <Grid container item md={12} xs={12} pb={'2%'} justifyContent={'center'} >     
                        <img src={bankData.bankImage} className={classes.bankImage}/> 
                    </Grid>
                </Grid>
            </Button>
            <Grid container item md={12} xs={12} justifyContent={'center'}>
                <Typography className={classes.bankName}>{bankData.bankName}</Typography>
            </Grid>
        </Grid>
    )
}
export default SingleBank